import { gboReservationPath, gmaSessionPath } from './session';

export const counterBypassEligiblePath = [...gboReservationPath, 'counter_bypass_eligible'];
export const skipTheCounterOriginPath = [...gmaSessionPath, 'skip_the_counter_origin'];
